<template>
  <div>
    <v-expansion-panels elevation="0" v-model="panel">
      <v-expansion-panel elevation="0" style="padding-bottom: 20px;">
        <v-expansion-panel-header style="padding: 35px">
          <h3 style="color: #42352e">Búsqueda detallada</h3>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-form ref="form" v-model="isFormValid" lazy-validation>
            <v-row>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="form.id"
                  label="No. Solicitud"
                  outlined
                  dense
                  :light="true"
                  background-color="white"
                  class="share-bar-clase"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-autocomplete
                  v-model="form.alianza_intermx_id"
                  label="Alianza inter mx"
                  placeholder="Requerido"
                  color="#00a7e4"
                  item-value="id"
                  item-text="nombre"
                  :items="alianzas"
                  type="text"
                  :light="true"
                  :loading="loadingForm"
                  id="alianza_intermx_ids"
                  dense
                  background-color="white"
                  outlined
                  clearable
                >
                </v-autocomplete>
              </v-col>
              <v-col cols="12" md="4">
                <v-menu
                  v-model="menuFecha"
                  :close-on-content-click="false"
                  max-width="290"
                >
                  <template #activator="{ on, attrs }">
                    <v-text-field
                      :value="datesSelectedString"
                      label="Rango de creación"
                      outlined
                      dense
                      v-on="on"
                      v-bind="attrs"
                      readonly
                      prepend-inner-icon="mdi-calendar"
                      :light="true"
                      background-color="white"
                      class="share-bar-clase"
                    ></v-text-field>
                  </template>
                  <v-card class="pa-0">
                    <v-date-picker
                      v-model="form.fecha_creacion"
                      range
                      locale="es"
                      selected-items-text="2 seleccionadas"
                    ></v-date-picker>
                    <v-card-actions>
                      <v-btn small text @click="form.fecha_creacion = []"
                        >Limpiar</v-btn
                      >
                      <v-spacer></v-spacer>
                      <v-btn
                        small
                        text
                        color="primary"
                        @click="menuFecha = false"
                        >Listo</v-btn
                      >
                    </v-card-actions>
                  </v-card>
                </v-menu>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="form.nombre"
                  label="Nombre"
                  outlined
                  dense
                  :light="true"
                  background-color="white"
                  class="share-bar-clase"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="form.apellido_paterno"
                  label="Apellido Paterno"
                  outlined
                  dense
                  :light="true"
                  background-color="white"
                  class="share-bar-clase"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="form.apellido_materno"
                  label="Apellido Materno"
                  outlined
                  dense
                  :light="true"
                  background-color="white"
                  class="share-bar-clase"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="form.rfc"
                  label="RFC"
                  outlined
                  dense
                  :rules="rfcRules"
                  :light="true"
                  background-color="white"
                  class="share-bar-clase"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="form.celular"
                  label="Teléfono"
                  outlined
                  dense
                  prepend-inner-icon="mdi-phone"
                  maxLength="10"
                  counter
                  :rules="[$rules.numeric, localRules.longDigit(10)]"
                  :light="true"
                  background-color="white"
                  class="share-bar-clase"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="form.correo_electronico"
                  label="Correo electrónico"
                  outlined
                  dense
                  prepend-inner-icon="mdi-email"
                  :rules="[$rules.email]"
                  :light="true"
                  background-color="white"
                  class="share-bar-clase"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="form.certificado"
                  label="Certificado"
                  outlined
                  dense
                  :light="true"
                  background-color="white"
                  class="share-bar-clase"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <div class="pt-5">
      <v-row>
        <v-col cols="6" md="2">
          <v-autocomplete
            v-model="form.status"
            label="Estatus"
            :items="statusList"
            item-text="etiquetaCrm"
            item-value="status"
            outlined
            dense
            clearable
          ></v-autocomplete>
        </v-col>
        <v-col cols="6" md="2">
          <v-autocomplete
            v-model="form.tipo"
            label="Tipo"
            :items="tiposSolicitudes"
            outlined
            dense
            clearable
          ></v-autocomplete>
        </v-col>
        <v-col cols="6" md="2">
          <v-select
            v-model="form.categoria"
            label="Categoria"
            :items="categorias"
            :loading="loadingForm"
            outlined
            dense
            clearable
          ></v-select>
        </v-col>
        <v-col cols="6" md="2">
          <v-select
            v-model="form.redencion_excepcion"
            label="Redención por Excepción"
            :items="redencionExcepcionOptions"
            item-text="text"
            item-value="value"
            outlined
            dense
            clearable
          ></v-select>
        </v-col>
        <v-col cols="6" md="2">
          <v-autocomplete
            v-model="form.marca"
            label="Marca"
            :items="marcas"
            :loading="loadingMarcas"
            outlined
            dense
            clearable
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" md="2">
          <v-btn
            class="common-botton"
            dark
            block
            :disabled="!isFormValid"
            :loading="loading"
            @click="updateSearch"
          >
            Filtrar
          </v-btn>
        </v-col>
        <v-col cols="12" md="2">
          <v-btn
            dark
            block
            outlined
            color="#00a7e4"
            rounded
            @click="clearForm()"
          >
            Limpiar
          </v-btn>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { getRamoList } from "@/services/ramo/ramo.service.js";
import { getAgentesByFilters } from "@/services/user/user.service";
import { getAlianzasList } from "@/services/alianzas/alianzas.service.js";
import { getMarcas } from "@/services/clubBeneficios/clubBeneficios";
import { getStatusList } from "@/services/solicitudes/Solicitudes"

export default {
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      form: {
        id: "",
        fecha_creacion: [],
        nombre: "",
        apellido_paterno: "",
        apellido_materno: "",
        celular: "",
        rfc: "",
        correo_electronico: "",
        empresa: "",
        tipificacion: "",
        operador_id: "",
        certificado: "",
        alianza_intermx_id: [],
        tipo: "",
        categoria: "",
        status: "",
        redencion_excepcion: "",
        marca: "",
      },
      menuFecha: false,
      agentes: [],
      operadores: [],
      asesores: [],
      ramos: [],
      tiposSolicitudes: ["Redencion", "Siniestros"],
      localRules: {
        longDigit(number) {
          return (v) =>
            !v ||
            v.length == number ||
            "Debe proporcionar " + number + " digitos";
        },
      },
      rol: JSON.parse(localStorage.getItem("roles"))[0].rol,
      rfcRules: [
        (v) =>
          (v || "").length <= 13 || "RFC No debe ser mayor de 13 caracteres",
        (v) =>
          /^([A-ZÑ\x26]{3,4}([0-9]{2})(0[1-9]|1[0-2])(0[1-9]|1[0-9]|2[0-9]|3[0-1]))([A-Z\d]{3})?$/.test(
            v
          ) || "RFC no es valido recordar escribir en mayusculas",
      ],
      alianzas: [],
      categorias: ["Beneficio", "Asistencia"],
      total: 0,
      usuarios: [],
      areaNegocioId: 15,
      loadingForm: false,
      panel: 0,
      statusList: [],
      marcas: [],
      loadingMarcas: false,
      redencionExcepcionOptions: [
        { text: "Si", value: 1 },
        { text: "No", value: 0 },
      ],
    };
  },

  computed: {
    isFormValid() {
      const isValidValue = (value) =>
        value !== "" && value !== null && value !== undefined;
      const hasNonEmptyField = Object.keys(this.form)
        .filter((key) => key !== "fecha_creacion")
        .some((key) => isValidValue(this.form[key]));

      const fechaCreacionValid =
        Array.isArray(this.form.fecha_creacion) &&
        this.form.fecha_creacion.length === 2 &&
        this.form.fecha_creacion.every(
          (date) => isValidValue(date) && this.isDate(date)
        );

      return hasNonEmptyField || fechaCreacionValid;
    },
    datesSelectedString() {
      if (this.form.fecha_creacion.length > 1)
        return `${this.formatDate(
          this.form.fecha_creacion[0]
        )} a ${this.formatDate(this.form.fecha_creacion[1])}`;
      return "";
    },
    minimoUnCampoLleno() {
      return (
        Object.keys(this.form).filter(
          (e) => !!this.form[e] || this.form[e] === 0
        ).length >= 1
      );
    },
    // currentOperadores() {
    //   return this.usuarios.filter((e) => e.rol == "BACKOFFICEEMAILS");
    // },
  },

  mounted() {
    this.getRamoList();
    this.getAgentesByFilters();
    this.getAlianzas();
    this.getStatusList();
    this.getMarcas();
  },

  methods: {
    async getRamoList() {
      this.ramos = await getRamoList();
    },
    async getStatusList() {
      let response  = await getStatusList();
      this.statusList = response.data;
    },
    async getMarcas() {
      this.loadingMarcas = true;
      try {
        this.marcas = await getMarcas();
      } catch {
        this.marcas = [];
        this.$toast.error("Ocurrió un error al obtener las marcas");
      } finally {
        this.loadingMarcas = false;
      }
    },
    updateSearch() {
      if (!this.isFormValid || !this.minimoUnCampoLleno) return;

      const normalizedId = String(this.form.id ?? "").trim();
      if (normalizedId !== "" && !/^\d+$/.test(normalizedId)) {
        this.$toast.error("El número de solicitud debe ser un número entero");
        return;
      }

      let payload = {};

      Object.keys(this.form).forEach((key) => {
        const rawValue = this.form[key];
        const value =
          key === "id"
            ? normalizedId !== ""
              ? Number(normalizedId)
              : ""
            : rawValue;
        if (
          value !== null &&
          value !== undefined &&
          !(Array.isArray(value) && value.length === 0) &&
          (value || value === 0)
        ) {
          if (
            key === "fecha_creacion" &&
            Array.isArray(value) &&
            value.length === 2
          ) {
            const [inicio, fin] = value;
            payload[key] = [
              `${this.formatDateToStartOfDay(inicio)}`,
              `${this.formatDateToEndOfDay(fin)}`,
            ];
          } else {
            payload[key] = value;
          }
        }
      });
      this.$emit("getAreaNegocioFilters", payload, this.areaNegocioId);
    },
    clearForm() {
      Object.keys(this.form).forEach((key) => {
        this.form[key] = "";
      });
      if (this.rol == "BACKOFFICEEMAILS")
        this.form.operador_id = localStorage.id;
    },
    formatDate(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    isDate(value) {
      const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
      return dateRegex.test(value) && !isNaN(Date.parse(value));
    },
    formatDateToStartOfDay(date) {
      return `${date} 00:00:00`;
    },
    formatDateToEndOfDay(date) {
      return `${date} 23:59:59`;
    },
    async getAgentesByFilters(limit = 10, page = 1) {
      let filters = { rol: ["BACKOFFICEINBOUND", "BACKOFFICEEMAILS"] };
      let response = await getAgentesByFilters(filters, limit, page);
      this.usuarios = response.data ?? [];
    },
    async getAlianzas() {
      let response = await getAlianzasList();
      this.alianzas = response.data;
    },
  },
};
</script>
<style scoped>
.v-expansion-panel {
  border-radius: 20px;
}
.v-expansion-panels {
  z-index: auto !important;
}
.v-expansion-panels:not(.v-expansion-panels--accordion):not(.v-expansion-panels--tile)
  > .v-expansion-panel--active {
  border-radius: 20px !important;
  background-color: #f7f8fa;
}
.v-expansion-panel-header {
  background-color: #f7f8fa;
  border-radius: 20px !important;
}
</style>
